import { FC } from 'react'
import { Col, Icon, Image, Row, Text } from '@/client/components'
import { IconName } from '@/client/components/Icon/types'
import { IFooterInfos } from '@/client/types'
import * as S from './styles'

/** Footer TrustedShops stars by locale */
const trustedShopStarsByLocale: Record<string, string> = {
  es: 'wdg-487ea5b9-83b7-4245-b755-fc9d78fa84bf',
  it: 'wdg-919764e7-f41f-4a1b-932d-cc624dfb7021',
  nl: 'wdg-0a8b1e33-d3fa-4962-be44-3beeca84652c',
  fr: 'wdg-db86fadf-e45c-4912-8af1-9f01208d635a',
  uk: 'wdg-6f6523e3-858b-4e34-8562-fb8bd562adb0',
  de: 'wdg-28260438-4d45-4d37-b8ba-68582c04c494'
}
const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE
const trustedShopStars = defaultLocale ? trustedShopStarsByLocale[defaultLocale] : undefined

export const FooterInfos: FC<IFooterInfos> = ({ footer_infos: { payment, shop_safely, certified, awards } }) => (
  <S.FooterInfos>
    <Row>
      <Col xs={12} lg={3}>
        <S.FooterInfosItem>
          <Text size='lg' family='heading' weight='bold'>
            {shop_safely.title}
          </Text>

          {trustedShopStars && (
            <>
              {/*  @ts-ignore */}
              <etrusted-widget data-etrusted-widget-id={trustedShopStars}></etrusted-widget>
            </>
          )}

          {process.env.NEXT_PUBLIC_DEFAULT_LOCALE == 'au' && (
            <>
              <a>⭐⭐⭐⭐⭐</a>
              <br></br>
              <a href='https://share.google/oiJkDlUX073ZgsKuw'>Visit us on google!</a>
            </>
          )}
        </S.FooterInfosItem>
      </Col>
      <Col xs={12} lg={3}>
        <S.FooterInfosItem>
          <Text size='lg' family='heading' weight='bold'>
            {payment.title}
          </Text>

          <S.PaymentList>
            {payment.credit_cards.map(({ name, icon }) => (
              <S.PaymentListItem key={name} title={name}>
                {icon ? (
                  <Icon name={icon as IconName} size={'s3'} />
                ) : (
                  <Text align='center' margin='0' weight='bold' style={{ fontSize: '0.4rem' }}>
                    <span dangerouslySetInnerHTML={{ __html: name }} />
                  </Text>
                )}
              </S.PaymentListItem>
            ))}
          </S.PaymentList>
        </S.FooterInfosItem>
      </Col>

      <Col xs={12} lg={3}>
        <S.FooterInfosItem>
          <Text size='lg' family='heading' weight='bold'>
            {certified.title}
          </Text>
          <S.HorizontalList>
            {certified.certifications.map(({ image: { url, alt, width, height } }, index) => (
              <S.WrapImage key={url} width={index === 1 ? '120' : '60'}>
                <Image
                  src={url}
                  alt={alt}
                  width={width}
                  height={height}
                  style={{ display: 'block', width: '100%', height: 'auto' }}
                />
              </S.WrapImage>
            ))}
          </S.HorizontalList>
        </S.FooterInfosItem>
      </Col>
      <Col xs={12} lg={3}>
        <S.FooterInfosItem>
          <Text size='lg' family='heading' weight='bold'>
            {awards.title}
          </Text>

          <S.HorizontalList>
            {awards.list.map(({ image: { url, alt, width, height } }) => (
              <S.WrapImage key={url} width='110'>
                <Image
                  src={url}
                  alt={alt}
                  width={width}
                  height={height}
                  style={{ display: 'block', width: '100%', height: 'auto' }}
                />
              </S.WrapImage>
            ))}
          </S.HorizontalList>
        </S.FooterInfosItem>
      </Col>
    </Row>
  </S.FooterInfos>
)
